// src\store\slice\auth-slice.ts

import { createSlice } from '@reduxjs/toolkit';
import jwtDecode from 'jwt-decode';
import { AuthState } from 'types/auth';

const initialState: AuthState = {
  authToken: null,
  decodedAuthToken: null,
  refreshToken: null,
  isMounted: false
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    updateToken: (state, data) => {
      const { authToken, refreshToken } = data.payload;
      const _updates: Partial<AuthState> = {};
      if (authToken) {
        _updates.authToken = authToken;
        _updates.decodedAuthToken = jwtDecode(authToken);
      }
      if (refreshToken) {
        _updates.refreshToken = refreshToken;
      }
      return {
        ...state,
        ..._updates,
        isMounted: true
      };
    },
    refreshToken: (state, data) => {
      const { authToken, refreshToken } = data.payload;
      const _updates: Partial<AuthState> = {};
      if (authToken) {
        _updates.authToken = authToken;
        _updates.decodedAuthToken = jwtDecode(authToken);
      }
      if (refreshToken) {
        _updates.refreshToken = refreshToken;
      }
      return {
        ...state,
        ..._updates,
        isMounted: true
      };
    },
    clearToken: (state) => {
      return {
        ...state,
        authToken: null,
        decodedAuthToken: null,
        refreshToken: null
      };
    },
    clearTokenByKey: (state, data) => {
      const { key }: { key: string } = data.payload;

      const _updates: Partial<AuthState> = {};
      if (key === 'auth-token') {
        _updates.authToken = null;
        _updates.decodedAuthToken = null;
      } else if (key === 'refresh-token') {
        _updates.refreshToken = null;
      }
      return {
        ...state,
        ..._updates
      };
    },
    updateMeInfo: (state, data) => {
      const { decodedAuthToken } = data.payload;
      return {
        ...state,
        decodedAuthToken,
        isMounted: true
      };
    },
    setIsLoading: (state, data) => {
      return { ...state, isMounted: data.payload };
    }
  }
});

export const { updateToken, clearToken, refreshToken, clearTokenByKey, updateMeInfo, setIsLoading } = authSlice.actions;

export default authSlice.reducer;
